var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hamburgerContainer"},on:{"click":_vm.toggleMobileMenu}},[_c('div',{class:_vm.toggledMobileMenu ? 'open' : 'closed',attrs:{"id":"hamburger"}},[_c('span'),_c('span'),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }